const brands = [ 
    { label: "Vintage", value: "Vintage" },
    { label: "Japanese Brand", value: "Japanese Brand" },
    { label: "Streetwear", value: "Streetwear" },
    { label: "Nike", value: "Nike" },
    { label: "Supreme", value: "Supreme" },
    { label: "Adidas", value: "Adidas" },
    { label: "Band Tees", value: "Band Tees" },
    { label: "Designer", value: "Designer" },
    { label: "Street Fashion", value: "Street Fashion" },
    { label: "Polo Ralph Lauren", value: "Polo Ralph Lauren" },
    { label: "American Vintage", value: "American Vintage" },
    { label: "Made In Usa", value: "Made In Usa" },
    { label: "Levi's", value: "Levi's" },
    { label: "Jordan Brand", value: "Jordan Brand" },
    { label: "Champion", value: "Champion" },
    { label: "Burberry", value: "Burberry" },
    { label: "Bape", value: "Bape" },
    { label: "Movie", value: "Movie" },
    { label: "Rare", value: "Rare" },
    { label: "Uniqlo", value: "Uniqlo" },
    { label: "Custom", value: "Custom" },
    { label: "Jewelry", value: "Jewelry" },
    { label: "Tommy Hilfiger", value: "Tommy Hilfiger" },
    { label: "Cartoon Network", value: "Cartoon Network" },
    { label: "Disney", value: "Disney" },
    { label: "Sportswear", value: "Sportswear" },
    { label: "The North Face", value: "The North Face" },
    { label: "Luxury", value: "Luxury" },
    { label: "Carhartt", value: "Carhartt" },
    { label: "Stussy", value: "Stussy" },
    { label: "Anti Social Social Club", value: "Anti Social Social Club" },
    { label: "New Era(20141)", value: "New Era(20141)" },
    { label: "Other", value: "Other" },
    { label: "Art", value: "Art" },
    { label: "Unbranded", value: "Unbranded" },
    { label: "NFL", value: "NFL" },
    { label: "Levi's Vintage Clothing", value: "Levi's Vintage Clothing" },
    { label: "Gucci", value: "Gucci" },
    { label: "Distressed Denim", value: "Distressed Denim" },
    { label: "Issey Miyake", value: "Issey Miyake" },
    { label: "Rock T Shirt", value: "Rock T Shirt" },
    { label: "Harley Davidson", value: "Harley Davidson" },
    { label: "Yves Saint Laurent", value: "Yves Saint Laurent" },
    { label: "Comme des Garcons", value: "Comme des Garcons" },
    { label: "MLB", value: "MLB" },
    { label: "Racing", value: "Racing" },
    { label: "Military", value: "Military" },
    { label: "Ralph Lauren", value: "Ralph Lauren" },
    { label: "NBA", value: "NBA" },
    { label: "Reebok", value: "Reebok" },
    { label: "Valentino", value: "Valentino" },
    { label: "Italian Designers", value: "Italian Designers" },
    { label: "Very Rare", value: "Very Rare" },
    { label: "Prada", value: "Prada" },
    { label: "Rap Tees", value: "Rap Tees" },
    { label: "Undercover", value: "Undercover" },
    { label: "Palace", value: "Palace" },
    { label: "Vans", value: "Vans" },
    { label: "Hanes", value: "Hanes" },
    { label: "Anima", value: "Anima" },
    { label: "Fruit Of The Loom", value: "Fruit Of The Loom" },
    { label: "Yohji Yamamoto", value: "Yohji Yamamoto" },
    { label: "Fila", value: "Fila" },
    { label: "Saint Laurent Paris", value: "Saint Laurent Paris" },
    { label: "Dior", value: "Dior" },
    { label: "Number (N)ine", value: "Number (N)ine" },
    { label: "Guess", value: "Guess" },
    { label: "Hysteric Glamour", value: "Hysteric Glamour" },
    { label: "Puma", value: "Puma" },
    { label: "Mickey Mouse", value: "Mickey Mouse" },
    { label: "Travis Scott", value: "Travis Scott" },
    { label: "Brand", value: "Brand" },
    { label: "Hawaiian Shirt", value: "Hawaiian Shirt" },
    { label: "Necklace", value: "Necklace" },
    { label: "Converse", value: "Converse" },
    { label: "Dolce & Gabbana", value: "Dolce & Gabbana" },
    { label: "Versace", value: "Versace" },
    { label: "Gildan", value: "Gildan" },
    { label: "Kapital", value: "Kapital" },
    { label: "Off-White", value: "Off-White" },
    { label: "Lacoste", value: "Lacoste" },
    { label: "Hype", value: "Hype" },
    { label: "Varsity Jacket", value: "Varsity Jacket" },
    { label: "Custom Made", value: "Custom Made" },
    { label: "Acne Studios", value: "Acne Studios" },
    { label: "Soccer Jersey", value: "Soccer Jersey" },
    { label: "Maison Margiela", value: "Maison Margiela" },
    { label: "Outdoor Life", value: "Outdoor Life" },
    { label: "Gap", value: "Gap" },
    { label: "Japanese Traditional", value: "Japanese Traditional" },
    { label: "Louis Vuitton", value: "Louis Vuitton" },
    { label: "Hat", value: "Hat" },
    { label: "Columbia", value: "Columbia" },
    { label: "HarlemBling", value: "HarlemBling" },
    { label: "Patagonia", value: "Patagonia" },
    { label: "Balenciaga", value: "Balenciaga" },
    { label: "Calvin Klein", value: "Calvin Klein" },
    { label: "Rick Owens", value: "Rick Owens" },
    { label: "Flannel", value: "Flannel" },
    { label: "Kappa", value: "Kappa" },
    { label: "Unknown", value: "Unknown" },
    { label: "Fear of God", value: "Fear of God" },
];

export default brands;
